import { Injectable } from "@angular/core";
import { SummaryPanelService } from "@senior-gestao-pessoas/angular-components";
import { user } from "@seniorsistemas/senior-platform-data";
import { switchMap } from "rxjs/operators";
import * as Tracksale from "../../../tracksale.js";
import { HcmConfigService } from "./hcm-config.service.js";
import { environment } from '../../../environments/environment';

@Injectable({
	providedIn: 'root'
})
export class TracksaleService {

	private employee;

	constructor(private summaryPanelService: SummaryPanelService,
				private hcmConfigService: HcmConfigService) { }

	public triggerNPS() {
		if (!this.isTestEnvironment() && environment.production) {
			this.summaryPanelService.getEmployee()
				.pipe(switchMap((employee) => {
					this.employee = employee;
					return this.hcmConfigService.getHcmSessionInfo();
				})).subscribe((userSessionInfo) => {
				const roles = this.getRolesFromSession(userSessionInfo);
				const jobPositions = this.getJobPositionsFromSession(userSessionInfo);
				user.getUserData().then((userData) => {
					Tracksale.triggerNps(this.employee.personName, userData.email, this.employee.personId, userSessionInfo.tenantId, roles, jobPositions);
				});
			});
		}
	}

	private isTestEnvironment() {
		const origin = window.location.ancestorOrigins && window.location.ancestorOrigins[0] ? window.location.ancestorOrigins[0] : window.location.origin;
		return origin.includes('platform-homologx') || origin.includes('platform-beta') || origin.includes('interno.senior.com.br');
	}

	private getRolesFromSession(userSessionInfo) {
		const roles = [];
		if (userSessionInfo) {
			userSessionInfo.employees.forEach((employee) => {
				employee.userRoles.forEach((role) => {
					roles[roles.length] = role.name;
				});
			});
		}
		return roles.join();
	}

	private getJobPositionsFromSession(userSessionInfo) {
		const jobPositions = [];
		if (userSessionInfo) {
			userSessionInfo.employees.forEach((employee) => {
				jobPositions[jobPositions.length] = employee.jobPosition;
			});
		}
		return jobPositions.join();
	}
}
